import { Link as MuiLink } from '@mui/material';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

const Link = ({ href = '#', ...props }) => {
  return <MuiLink to={href} component={NavLink} {...props} />;
};

Link.propTypes = {
  href: PropTypes.string,
};

export default Link;
